import { useRef, useEffect } from "react";
import { BsFillPatchCheckFill } from "react-icons/bs";
import { FiCamera } from "react-icons/fi";
import { getMediaUrl, getProfileImage } from "../../utils/helpers";

export default function Conversation({
  chats,
  activeChat,
  onSelectChat,
  loadMore,
  hasMore,
  loading,
  page,
}) {
  const listRef = useRef(null);

  useEffect(() => {
    const container = listRef.current;
    if (!container) return;

    const onScroll = () => {
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 80 &&
        hasMore &&
        !loading
      ) {
        loadMore(page + 1);
      }
    };

    container.addEventListener("scroll", onScroll);
    return () => container.removeEventListener("scroll", onScroll);
  }, [page, hasMore, loading, loadMore]);

  return (
    <aside className="border-r border-gray-800 p-4 text-gray-200 h-full">
      {/* 🔥 THIS is the scroll container */}
      <div
        ref={listRef}
        className="flex flex-col gap-3 overflow-y-auto h-full"
      >
        {chats.map((item) => (
          <div
            key={item.conversationId}
            onClick={() => onSelectChat(item)}
            className={`w-full flex items-center gap-3 p-3 rounded-lg cursor-pointer border-2
              ${item.conversationId === activeChat?.conversationId
                ? "bg-[#3d0d2f] border-red-500"
                : "border-transparent hover:bg-gray-900"
              }`}
          >
            <div className="relative">
              <img
                src={
                  item?.remoteUser?.ppImageURL
                    ? getProfileImage(getMediaUrl(item.remoteUser.ppImageURL))
                    : getProfileImage()
                }
                className="w-12 h-12 rounded-full"
                alt=""
              />
              <span
                className={`absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-black
                  ${item?.remoteUser?.status === "online"
                    ? "bg-green-500"
                    : "bg-red-500"
                  }`}
              />
            </div>

            <div className="flex-1">
              <div className="flex justify-between items-center">
                <div className="font-semibold text-sm flex items-center gap-2">
                  {item?.remoteUser?.name}
                  {item?.remoteUser?.is_verified && (
                    <BsFillPatchCheckFill className="text-blue-600" />
                  )}
                </div>
                {item?.unreadCount > 0 && (
                  <div className="bg-red-500 text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full">
                    {item.unreadCount}
                  </div>
                )}
              </div>

              <div className="text-xs text-gray-400 truncate flex items-center gap-1 mt-1">
                {item?.lastMessage ? (
                  item.lastMessage.access === "PAID" ? (
                    <>🔒 Sent Premium Content!</>
                  ) : item.lastMessage.kind?.toLowerCase() === "media" ? (
                    <>
                      <FiCamera className="w-3 h-3" />
                      Image
                    </>
                  ) : (
                    item.lastMessage.text
                  )
                ) : (
                  <span className="italic">No messages yet</span>
                )}
              </div>
            </div>
          </div>
        ))}

        {loading && (
          <div className="text-xs text-gray-400 text-center py-2">
            Loading conversations...
          </div>
        )}
      </div>
    </aside>
  );
}